import { QuotesIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Quote = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <QuotesIcon size={Sizes[size]} color={fill || stroke} {...rest} />;
};

Quote.displayName = 'Quote';
